import React, { Component } from 'react';
import { toast } from 'react-toastify';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

class Toaster extends Component {

  static getSuccessToaster(icon, message) {
    toast.success(() => (
      <div>
        <FontAwesomeIcon icon={`${icon}`} />
        {`${message}`}
      </div>
    ));
  }

  static getErrorToaster(icon, message) {
    toast.error(() => (
      <div>
        <FontAwesomeIcon icon={`${icon}`} />
        {`${message}`}
      </div>
    ))
  }

  static getFailureToaster(error, icon, message) {
    toast.error(() => (
      <div>
        <FontAwesomeIcon icon={`${icon}`} />
        {error.response && error.response.data && error.response.data.error && error.response.data.error.includes(`${message}`)
          ? `${message}` : 'Something went wrong'}
      </div>
    ));
  }
}

export default Toaster;



// WEBPACK FOOTER //
// ./src/components/Toaster.js